import React from 'react'
import {seoPageChange} from '../../utils'

class UpdateEntry extends React.Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() { seoPageChange() }

  render() {

    const { version, downloadLink, hash = "none" } = this.props;

    return (
      <section className="ArchiveItem s4">
        <div>
          <a href={downloadLink}>Download version v{version}</a>
        </div>
        <div>
          SHA-256: {hash}
        </div>
      </section>
    )
  }

}

export default UpdateEntry;



// WEBPACK FOOTER //
// ./src/components/marketing/ArchiveItem.js